import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ciManageForecastTreeData: [],
  ciManageForecastBottlerData: {
    bottler: null,
    bottlerOwnerCode: null,
  },
  ciManageForecastFinalTreeData: [],
};

const CIManageScreenRedux = createSlice({
  name: "CIManageScreenRedux",
  initialState,
  reducers: {
    setCIManageForecastTreeData: (state, action) => {
      state.ciManageForecastTreeData = action.payload;
    },
    setCIManageForecastBottlerData: (state, action) => {
      state.ciManageForecastBottlerData = action.payload;
    },
    setCIManageForecastFinalTreeData: (state, action) => {
      state.ciManageForecastFinalTreeData = action.payload;
    },
  },
});

export const {
  setCIManageForecastTreeData,
  setCIManageForecastBottlerData,
  setCIManageForecastFinalTreeData,
} = CIManageScreenRedux.actions;
export default CIManageScreenRedux.reducer;
